import { useEffect, useState } from "react";
import styles from "./expenseList.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { TableLoader } from "../../../../../components/LoaderC";
import { Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, IconButton, Button, Slide } from "@mui/material";
import ListFilters from "./components/ListFilters";
import ListRecords from "./components/ListRecords";
import ListDonutWidget from "./components/ListDonutWidget";
import { X, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const PayeeInitials = ({ payee }) => {
  let payeeIn = '-';
  if (payee) {
    const cleanName = payee.replace(/\//g, " ").trim();
    const parts = cleanName.split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "-";
    const initials = parts.length === 1 ? parts[0][0] : parts[0][0] + parts[parts.length - 1][0];
    payeeIn = initials.toUpperCase();
  }

  return <p>{payeeIn}</p>
}

const ExpenseList = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [contentLoading, setContentLoading] = useState(true);
  const [filterOpen, setFilterOpen] = useState(false);
  const [allData, setAllData] = useState([]);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [payeeList, setPayeeList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectecId, setSelectecId] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [filterredData, setFilterredData] = useState([]);
  const [currentFilterValue, setCurrentFilterValue] = useState("");
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(-1);
  const [filterData, setFilterData] = useState({ searchKey: "", property: "", apartment: "", status: "", due_date: null, category: "", payee: "" });
  const [propertyList, setPropertyList] = useState([]);
  const [donutGraphData, setDonutGraphData] = useState([]);
  const [apartmentList, setApartmentList] = useState([]);

  useEffect(() => {
    const fetchAllProperties = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        let propertyData = response.data.data;

        propertyData = [{ value: "all", label: "All", apartments: [] }].concat(propertyData);
        setPropertyList(propertyData);

        if (localStorage.getItem("propertyFilterData")) {
          let filterPropertyId = localStorage.getItem("propertyFilterData");
          localStorage.removeItem("propertyFilterData");

          setFilterData((prev) => {
            return { ...prev, property: parseInt(filterPropertyId) };
          });

          let apartmentListTemp = [];
          propertyData?.map((i) => {
            if (i.value === parseInt(filterPropertyId)) {
              apartmentListTemp = i.apartments;
            }
            return null;
          });

          apartmentListTemp = [{ value: "all", label: "All", apartments: [] }].concat(apartmentListTemp);
          setApartmentList(apartmentListTemp);
        }

        if (localStorage.getItem("apartmentFilterData")) {
          let apartmentFilter = localStorage.getItem("apartmentFilterData");
          localStorage.removeItem("apartmentFilterData");
          apartmentFilter = parseInt(apartmentFilter);

          setFilterData((prev) => {
            return { ...prev, apartment: parseInt(apartmentFilter) };
          });
        }
      });
    };
    fetchAllProperties();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    async function getAllData() {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/expenses", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          setContentLoading(false);
          setAllData(response.data.data);
        })
        .catch((error) => {
          setContentLoading(false);
        });
    }
    getAllData();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    let filterredDataTemp = allData;

    if (filterData.searchKey !== "") {
      let inputVal = filterData.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredDataTemp = filterredDataTemp.filter((item) => {
        return (item.description.toLowerCase().includes(inputVal) || item.property_name.toLowerCase().includes(inputVal) || item.apt_no?.toLowerCase()?.includes(inputVal) || item.formatted_amount.toLowerCase().includes(inputVal) || item.payee_name.toLowerCase().includes(inputVal));
      });
    }

    if (filterData.property !== "" && filterData.property !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i.property_id === filterData.property);
    }

    if (filterData.apartment !== "" && filterData.apartment !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i.apt_id === filterData.apartment);
    }

    if (filterData.category && filterData.category !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => {
        return i.category_id === filterData.category;
      });
    }

    if (filterData.payee && filterData.payee !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => {
        return i.payee_id === filterData.payee;
      });
    }

    if (filterData.view !== "" && filterData.view !== "all") {
      if (filterData.view === "active") {
        filterredDataTemp = filterredDataTemp.filter((i) => i.is_archived === 0);
      }
      if (filterData.view === "archived") {
        filterredDataTemp = filterredDataTemp.filter((i) => i.is_archived === 1);
      }
    }

    if (filterData.status !== "" && filterData.status !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i.status === filterData.status);
    }

    if (filterData.due_date && filterData.due_date !== "") {
      filterredDataTemp = filterredDataTemp.filter((i) => {
        var dateR = filterData.due_date;
        if (dayjs(dayjs(i.due_date).format("YYYY-MM-DD")).isBetween(dayjs(dateR[0]).format("YYYY-MM-DD"), dayjs(dateR[1]).format("YYYY-MM-DD"), undefined, [])) {
          return true;
        }
        return false;
      });
    }

    setFilterredData(filterredDataTemp);
  }, [allData, filterData]);

  useEffect(() => {
    getDonutGraphData("");
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const buildUrl = () => {
      if (currentFilterValue === "search" || currentFilterValue === "status" || currentFilterValue === "payee")
        return;
      const queryParams = [];

      if (filterData.property && filterData.property !== "all") {
        queryParams.push(`property_id=${filterData.property}`);
      }

      if (filterData.apartment && filterData.apartment !== "all") {
        queryParams.push(`apt_id=${filterData.apartment}`);
      }

      if (Array.isArray(filterData.due_date) && filterData.due_date.length === 2) {
        const start = filterData.due_date[0]?.toLocaleDateString("en-CA");
        const end = filterData.due_date[1]?.toLocaleDateString("en-CA");

        queryParams.push(`start=${start}`);
        queryParams.push(`end=${end}`);
      }

      if (filterData.category && filterData.category !== "all") {
        queryParams.push(`category_id=${filterData.category}`);
      }

      let queryParamsUrl = "";

      if (queryParams.length) {
        queryParamsUrl = `?${queryParams.join("&")}`;
      }

      getDonutGraphData(queryParamsUrl);
    };

    if (currentFilterValue) {
      buildUrl();
    }
  }, [currentFilterValue, filterData]);

  useEffect(() => {
    const getCategoryList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/expense-categories", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setExpenseCategories([
          { title: "All", id: "all" },
          ...response.data.data,
        ]);

        if (localStorage.getItem("expenseCategoryFilterData")) {
          let categoryFilter = localStorage.getItem("expenseCategoryFilterData");
          localStorage.removeItem("expenseCategoryFilterData");
          categoryFilter = parseInt(categoryFilter);

          setFilterData((prev) => {
            return { ...prev, category: parseInt(categoryFilter) };
          });

          setCurrentFilterValue("category");
        }
      }).catch(() => { });
    };

    getCategoryList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const getPayeeList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/payees", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setPayeeList([{ company_name: "All", id: "all" }, ...response.data.data]);
      }).catch(() => { });
    };

    getPayeeList();
  }, [getAccessTokenSilently]);

  const selectProperty = (e) => {
    let apartmentListTemp = [];
    propertyList?.map((i) => {
      if (i.value === e) {
        apartmentListTemp = i.apartments;
      }
      return null;
    });

    apartmentListTemp = [{ value: "all", label: "All", apartments: [] }].concat(
      apartmentListTemp
    );
    setApartmentList(apartmentListTemp);
  };

  async function getDonutGraphData(queryParams) {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    let url = process.env.REACT_APP_PAYMENT_API_URL + "v1/expense-data";

    if (queryParams) {
      url = url + queryParams;
    }
    axios(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setDonutGraphData(response.data.data);
    }).catch((error) => { });
  }

  const confirmDelete = async () => {
    setDeleteModalOpen(false);
    setContentLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(process.env.REACT_APP_PAYMENT_API_URL + "v1/expenses/" + selectecId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
      setContentLoading(false);

      setAllData((prev) => {
        return prev?.filter((i) => i?.id !== selectecId);
      });
      setSelectecId(0);
    }).catch((error) => {
      if (typeof error.response !== "undefined") setSnackbarOpen(true);
      setSnackbarMsg(error.response.data.message);
      setContentLoading(false);
    });
  };

  return (<div className={`${styles.BodyCon}`}>
    <div className={`${styles.mainCardDiv}`}>
      <div className={`${styles.mainCard}`}>
        <div className="control-pane">
          {contentLoading && (<div className="Loader TableLoader">
            <TableLoader />
          </div>)}

          <div className={`${styles.Row}`}>
            {!contentLoading && (<>
              <ListFilters
                setPage={setPage.bind(this)}
                setFilterData={setFilterData}
                setFilterOpen={setFilterOpen}
                filterOpen={filterOpen}
                filterData={filterData}
                selectProperty={selectProperty}
                propertyList={propertyList}
                apartmentList={apartmentList}
                setCurrentFilterValue={setCurrentFilterValue}
                expenseCategories={expenseCategories}
                payeeList={payeeList}
              />

              <div className={`${styles.IncomeListingBody}`}>
                <div className={`${styles.IncomeListSec}`}>

                  {filterredData.length > 0 && (<ListRecords
                    filterredData={filterredData}
                    filterData={filterData}
                    perPage={perPage}
                    page={page}
                    setDeleteModalOpen={setDeleteModalOpen}
                    setSelectecId={setSelectecId}
                  />)}

                  {filterredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                    <div className={`${styles.NoDataIMG}`}>
                      <img src="/static/img/no-expense.png" alt="No Data" />
                    </div>
                    <p className={`${styles.NoDataText}`}>Expense list is empty.</p>
                    <p className={`${styles.NoDataTextSub}`}>Time to track your spending!</p>
                  </div>)}
                </div>

                <div className={`${styles.IncomeGraphSec}`}>
                  <ListDonutWidget donutGraphData={donutGraphData} />
                </div>
              </div>

              <div className={`${styles.ListMobileView}`}>
                {filterredData?.map(item => {
                  return (<Link to={"/expense/all-expense/edit/" + item?.id} className={`${styles.MaintenanceReqCard}`}>
                    <div className={`${styles.CardImgSec} Secondary`}>
                      <PayeeInitials payee={item?.payee_name} />
                    </div>
                    <div className={`${styles.MainReCardCon}`}>
                      <div>
                        <div className={`${styles.MainReCardIdStatus}`}>
                          <p className={`${styles.Title}`}>{item?.payee_name}</p>
                          {item?.file_url && <a href={item.file_url} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); }} className={`${styles.AttatchmentClass}`}><img src="/static/img/bill-icon.svg" alt="" /></a>}
                          <button className={`${styles.ExpenseDeleteBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectecId(item.id); setDeleteModalOpen(true); }}><Trash2 /></button>
                        </div>
                        <div className={`${styles.MainReCardIdStatus}`}>
                          <p className={`${styles.MainReID}`}>Submitted: {item?.due_date ? dayjs(item?.due_date).format("MM/DD/YYYY") : " - "}</p>
                          {item?.status === 0 && (<span className={`${styles.StatusBadge} ${styles.Pending}`}>Upcoming</span>)}
                          {item?.status === 1 && (<span className={`${styles.StatusBadge} ${styles.Failed}`}>Due</span>)}
                          {item?.status === 2 && (<span className={`${styles.StatusBadge} ${styles.Confirm}`}>Paid: {dayjs(item?.payment_date).format("MM/DD/YYYY")}</span>)}
                        </div>
                        <div className={`${styles.MainReCardIdStatus}`}>
                          <p className={`${styles.MainReID}`}>{item?.category?.title} <span>${item?.formatted_amount}</span></p>
                        </div>
                        <div className={`${styles.MainReCardIdStatusTwo}`}>
                          <p className={`${styles.MainReID}`}>{item?.property_name} {item?.apt_name ? <span>{item?.apt_name}</span> : ""}</p>
                        </div>
                      </div>
                    </div>
                  </Link>)
                })}
              </div>

              {/* {filterredData.length > 0 && (<div className="Pagination TablePaginationNew ">
                <TablePagination
                  count={filterredData.length}
                  color="primary"
                  page={page}
                  rowsPerPage={perPage}
                  onPageChange={(e, v) => setPage(v)}
                  rowsPerPageOptions={[
                    { label: "4", value: 4 },
                    { label: "8", value: 8 },
                    { label: "16", value: 16 },
                    { label: "All", value: -1 },
                  ]}
                  onRowsPerPageChange={(e) => {
                    setPage(0);
                    setPerPage(e.target.value);
                  }}
                  labelRowsPerPage={"Payments per Page:"}
                />
              </div>)} */}
            </>)}
          </div>
        </div>
      </div>
    </div>
    <Dialog
      open={deleteModalOpen}
      onClose={(e) => setDeleteModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Would you like to delete this expense?
        <button onClick={(e) => setDeleteModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The expense information will be removed immediately.You can't undo this action.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />
  </div >);
};

export default ExpenseList;